<template>
  <ODialog ref="dialog" :maxWidth="800" hideWhenLoading>
    <v-card v-if="row != null">
      <OperationDialogTitle v-bind="row" @close="dismiss" />
      <v-card-text class="d-flex flex-row flex-wrap pa-3 children-pa-3">
        <OCapCont class="w-1/3" label="Módulo">
          <router-link :to="`/clients/${row.clientId}`">
            {{ row.clientId }}
          </router-link>
        </OCapCont>

        <OCapCont class="w-2/3" label="Veículo">
          <ReadonlyVehicle v-if="vehicle != null" :vehicle="vehicle" />
        </OCapCont>

        <OCapCont class="w-1/3" label="Data do evento">
          {{ row.timestamp | moment('DD/MMM/YYYY HH:mm:ss') }}
        </OCapCont>

        <OCapCont class="w-1/3" label="Data do registro">
          {{ row.updatedAt | moment('DD/MMM/YYYY HH:mm:ss') }}
        </OCapCont>

        <template v-if="row.type == 'firmwareUpdate'">
          <div class="w-full">
            <v-divider />
          </div>
          <OCapCont class="w-full" label="Versão do firmware">
            <span class="mono"
              >0x{{ get('firmware.version', 0).toString(16) }}</span
            >
          </OCapCont>
        </template>

        <template v-if="row.type == 'logistic'">
          <div class="w-full">
            <v-divider />
          </div>
          <OCapCont class="w-1/2" label="Estoque de origem">
            {{ get('fromDepot.name') }}
          </OCapCont>
          <OCapCont class="w-1/2" label="Estoque de destino">
            {{ get('toDepot.name') }}
          </OCapCont>
        </template>

        <template v-if="hasBilling">
          <div class="w-full">
            <v-divider />
          </div>
          <OCapCont class="w-2/3" label="Técnico">
            {{ get('technician.name') }}
          </OCapCont>
          <OCapCont class="w-1/3" label="Valor técnico">
            {{ get('techValue') }}
          </OCapCont>
          <OCapCont class="w-1/3" label="Centro de Custo">
            {{ get('costCenter.name') }}
          </OCapCont>
          <OCapCont class="w-1/3" label="Tipo de Produto">
            {{ get('productType.alias') }}
          </OCapCont>
          <OCapCont class="w-1/3" label="Valor CC">
            {{ get('costCenterValue') }}
          </OCapCont>
        </template>

        <div class="w-full">
          <v-divider />
        </div>

        <OCapCont class="w-full" label="Comentários">
          {{ row.comments || '─' }}
        </OCapCont>

        <RowDates :value="row" />
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import { ClientHistory, Vehicle } from '@/models'
import RowDates from './RowDates.vue'
import OperationDialogTitle from './OperationDialogTitle.vue'
import ReadonlyVehicle from './ReadonlyVehicle.vue'
import _ from 'lodash'

export default {
  components: { RowDates, ReadonlyVehicle, OperationDialogTitle },
  data() {
    return {
      isLoading: true,
      row: null,
      vehicle: null
    }
  },
  computed: {
    hasBilling() {
      return this.row && this.row.type == 'installation'
    }
  },
  methods: {
    get(prop, defVal) {
      let res = _.get(this.row, prop)
      if (
        res == null ||
        (typeof res.valueOf() === 'string' && res.trim().length < 1)
      )
        res = defVal
      return res
    },

    open({ historyId }) {
      this.$refs.dialog.$loading(() => this.fetchData(historyId))
      return this.$refs.dialog.$open()
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    async fetchData(historyId) {
      let row = await ClientHistory.findById(historyId)
      let vehicle = null
      if (row.vehicleId) vehicle = await Vehicle.findById(row.vehicleId)
      this.row = row
      this.vehicle = vehicle
    }
  }
}
</script>

<style></style>
